// OrganismDisplayViewEduPreviewDesktop.jsx
// 데스크탑 전용 교육 콘텐츠 미리보기 컴포넌트

import React, { useEffect, useState, useRef, useCallback } from "react";
import styled from "styled-components";
import { toPng, toSvg } from "html-to-image";
import { palette } from "../../../../assets/styles/Palette";
import { Body3 } from "../../../../assets/styles/Typography";
import { Button } from "../../../../assets/styles/ButtonStyle";
import MoleculeSizeArea from "../molecules/MoleculeSizeArea";
import MoleculeBackgroundModern from "../../../CreateEducationContentPage/components/molecules/MoleculeBackgroundModern";
import MoleculeBackgroundSimple from "../../../CreateEducationContentPage/components/molecules/MoleculeBackgroundSimple";
import MoleculeBackgroundSimpleWide from "../../../CreateInfoContentPage/components/molecules/MoleculeBackgroundSimpleWide";
import MoleculeBackgroundSimpleWideLink from "../../../CreateInfoContentPage/components/molecules/MoleculeBackgroundSimpleWideLink";
import Markdown from "markdown-to-jsx";
import logo from "../../../../assets/images/penLogo.png";
import Info_Background from "../../../../assets/images/Background/Info_background.png";
import MoleculeLinkContentInfoBoard from "../../../AutodisplayView/components/molecules/MoleculeLinkContentInfoBoard";
import MoleculeGeneralContentInfoBoard from "../../../AutodisplayView/components/molecules/MoleculeGeneralContentInfoBoard";
import {  getWeatherDataInDB } from "../../../../utils/indexedDB";
import { useAtom } from "jotai";
import {
  AUTODISPLAY_REACT_STATE,
} from "../../../AtomStates";

// 테마별 컬러 매핑 객체
const themeColors = {
  dark: {
    mainColor: "white",
    MainContainerBackgroundLinearGradient01: "rgba(0, 0, 0, 0.4)",
    MainContainerBackgroundLinearGradient02: "rgba(0, 0, 0, 0.4)",
    MainPanelBackgroundLinearGradient01: "rgba(0, 0, 0, 0.3)",
    MainPanelBackgroundLinearGradient02: "rgba(0, 0, 0, 0.5)",
    MainPanelBackgroundLinearGradient03: "rgba(0, 0, 0, 0.3)",
    MainPanelOutline: "rgba(255, 255, 255, 0.4)",
    WeatherPanelBackgroundLinearGradient01: "rgba(0, 0, 0, 0.3)",
    WeatherPanelBackgroundLinearGradient02: "rgba(0, 0, 0, 0.5)",
    WeatherPanelBackgroundLinearGradient03: "rgba(0, 0, 0, 0.3)",
    WeatherPanelOutline: "rgba(255, 255, 255, 0.4)",
    WeatherLabelColor: "rgba(255, 255, 255, 0.6)",
    bottomMessageBackground: "rgba(255, 255, 255, 0.2)",
  },
  light: {
    mainColor: "black",
    MainContainerBackgroundLinearGradient01: "rgba(255, 255, 255, 0.4)",
    MainContainerBackgroundLinearGradient02: "rgba(255, 255, 255, 0.4)",
    MainPanelBackgroundLinearGradient01: "rgba(255, 255, 255, 0.3)",
    MainPanelBackgroundLinearGradient02: "rgba(255, 255, 255, 0.5)",
    MainPanelBackgroundLinearGradient03: "rgba(255, 255, 255, 0.3)",
    MainPanelOutline: "rgba(255, 255, 255, 0.4)",
    WeatherPanelBackgroundLinearGradient01: "rgba(255, 255, 255, 0.3)",
    WeatherPanelBackgroundLinearGradient02: "rgba(255, 255, 255, 0.5)",
    WeatherPanelBackgroundLinearGradient03: "rgba(255, 255, 255, 0.3)",
    MainPanelOutline: "rgba(255, 255, 255, 0.4)",
    WeatherLabelColor: "rgba(0, 0, 0, 0.6)",
    bottomMessageBackground: "rgba(0, 0, 0, 0.2)",
  },
};

const getThemeColor = (colorName, themeMode = "dark") => {
  const theme = themeColors[themeMode] || themeColors.dark;
  return theme[colorName] || themeColors.dark[colorName];
};

const OrganismDisplayViewInfoPreviewDesktop = ({
  template,
  onClose,
  title,
  jsonData,
  markdownData,
  titleData,
  contentsPurpose,
  contentsDesignConcept,
  displayWidth,
  displayHeight,
  contentsType,
  linkUrl
}) => {
  // console.log("🖥️ 데스크탑 전용 미리보기 컴포넌트:", contentsDesignConcept);
  // console.log("🖥️ 데스크탑 전용 미리보기 컴포넌트 - contentsType:", contentsType);
  // console.log("🖥️ 데스크탑 전용 미리보기 컴포넌트 - linkUrl:", linkUrl);

   // ✅ 재생 상태는 컴포넌트 최상위에서 관리 
 const [playing, setPlaying] = useState(true); 
 const handleTogglePlay = useCallback((next) => { 
   setPlaying(next); 
   // TODO: 여기서 슬라이드쇼 타이머 start/stop 연결 
 }, []); 
 const handlePrev = useCallback(() => { 
   // TODO: 이전 슬라이드 이동 로직 
 }, []); 
 const handleNext = useCallback(() => { 
   // TODO: 다음 슬라이드 이동 로직 
 }, []); 
  const [orientation, setOrientation] = useState("landscape");
  const [themeMode, setThemeMode] = useState("light");
  const [reactState] = useAtom(AUTODISPLAY_REACT_STATE);
  const [weatherData, setWeatherData] = useState( {
    temperature: null,
    wind: null,
    humidity: null,
    precipitation: null,
    minTemperature: null,
    maxTemperature: null,
    weatherMain: null,
    weatherIcon: null,
    sky: null,
    pty: null,
    icon: null,
    });


  const [isWider, setIsWider] = useState(false);
  const [isTaller, setIsTaller] = useState(false);
  const [showHeader, setShowHeader] = useState(false);
  
  

  const previewRef = useRef(null);
  const downloadRef = useRef(null); // PNG 생성용 별도 ref

  const [originalSize, setOriginalSize] = useState({
    width: 3840,
    height: 2160,
  });

  const [previewSize, setPreviewSize] = useState({
    width: 800,
    height: 450,
  });
  const weatherLocationRef = useRef({ lat: null, lon: null });



    useEffect(() => {
      if (reactState === "fixed" && displayWidth > 0 && displayHeight > 0) {
        const fixedRatio = displayWidth / displayHeight;
        setOrientation(fixedRatio > 1 ? "landscape" : "portrait");
        setIsWider(fixedRatio > 16 / 9);
        setIsTaller(fixedRatio < 9 / 16);
      }
    }, [reactState, displayWidth, displayHeight]);
  
    // 반응형 모드일 때만 실행되는 useEffect (기존과 완전히 동일)
    useEffect(() => {
      // reactState가 'active'이거나 undefined일 때만 실행 (기존 동작)
      if (reactState === "active" || reactState === undefined) {
        const handleResize = () => {
          const currentRatio = window.innerWidth / window.innerHeight;
          setOrientation(currentRatio > 1 ? "landscape" : "portrait");
          setIsWider(currentRatio > 16 / 9);
          setIsTaller(currentRatio < 9 / 16);
        };
  
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }
    }, []);

    // 페이지 공용 날씨 로딩 (OpenWeather 우선, lat/lon 사용, 없으면 city 키워드)
      const fetchWeatherForPage = useCallback(async () => {
        try {
          // 1) 페이지 수준으로 추출한 위치(lat/lon) 우선 사용
          const { x, y } = weatherLocationRef.current || {};
    
          if (x && y && typeof getWeatherDataInDB === "function") {
            const res = await getWeatherDataInDB({ x, y });
            const data = res?.data?.data;
            // console.log("fetchWeatherForPage - WeatherDataInDB by x/y:", data);
            if (data) {
              setWeatherData((prev) => ({
                ...prev,
                temperature: Math.round(data.temp),
                minTemperature: Math.round(data.temp_min),
                maxTemperature: Math.round(data.temp_max),
                wind: data.wsd,
                humidity: Math.round(data.humidity),
                precipitation: data.rain_1h,
                weatherMain: data.weather_main,
                weatherIcon: data.weather_icon,
                icon: data.weather_icon,
              }));
              return;
            }
          }
        } catch (e) {
          // 조용히 실패 처리 (하위 컴포넌트가 자체 fallback 가능)
          // console.warn("fetchWeatherForPage failed:", e);
        }
      }, []);

  

  // displayWidth와 displayHeight가 변경될 때 원본 사이즈 업데이트
  useEffect(() => {
    console.log(
      "데스크탑 미리보기 - DisplayWidth:",
      displayWidth,
      "DisplayHeight:",
      displayHeight
    );
    if (displayWidth && displayHeight) {
      const width = parseInt(displayWidth);
      const height = parseInt(displayHeight);

      setOriginalSize({
        width: width,
        height: height,
      });

      // 화면에 맞는 미리보기 사이즈 계산 (화면을 완전히 채우도록)
      const maxWidth = window.innerWidth;
      const maxHeight = window.innerHeight - 120; // 헤더와 사이즈 영역 높이 고려

      // 화면을 완전히 채우도록 설정 (비율 무시)
      setPreviewSize({
        width: maxWidth,
        height: maxHeight,
      });
    }
  }, [displayWidth, displayHeight]);

  // 창 크기 변경시 미리보기 사이즈 재계산
  useEffect(() => {
    const handleResize = () => {
      const maxWidth = window.innerWidth;
      const maxHeight = window.innerHeight - 120; // 헤더와 사이즈 영역 높이 고려

      // 화면을 완전히 채우도록 설정 (비율 무시)
      setPreviewSize({
        width: maxWidth,
        height: maxHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [originalSize]);

  const handleDownloadPng = useCallback(() => {
    if (downloadRef.current === null) {
      return;
    }

    // downloadRef 요소를 임시로 보이게 만들기
    const downloadElement = downloadRef.current;
    downloadElement.style.position = "fixed";
    downloadElement.style.top = "0";
    downloadElement.style.left = "0";
    downloadElement.style.zIndex = "10000";

    // 약간의 지연을 두어 렌더링 완료 후 캡처
    setTimeout(() => {
      toPng(downloadElement, {
        cacheBust: true,
        width: originalSize.width,
        height: originalSize.height,
        style: {
          transform: "none",
          width: `${originalSize.width}px`,
          height: `${originalSize.height}px`,
        },
      })
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.download = `${title || "template"}.png`;
          link.href = dataUrl;
          link.click();

          // 다시 숨기기
          downloadElement.style.position = "absolute";
          downloadElement.style.top = "-9999px";
          downloadElement.style.left = "-9999px";
          downloadElement.style.zIndex = "-1";
        })
        .catch((err) => {
          console.log("데스크탑 미리보기 PNG 생성 오류:", err);

          // 에러 시에도 다시 숨기기
          downloadElement.style.position = "absolute";
          downloadElement.style.top = "-9999px";
          downloadElement.style.left = "-9999px";
          downloadElement.style.zIndex = "-1";
        });
    }, 100);
  }, [originalSize, title]);

  const handleDownloadSvg = useCallback(() => {
    if (downloadRef.current === null) {
      return;
    }

    // downloadRef 요소를 임시로 보이게 만들기
    const downloadElement = downloadRef.current;
    downloadElement.style.position = "fixed";
    downloadElement.style.top = "0";
    downloadElement.style.left = "0";
    downloadElement.style.zIndex = "10000";

    // 약간의 지연을 두어 렌더링 완료 후 캡처
    setTimeout(() => {
      toSvg(downloadElement, {
        cacheBust: true,
        width: originalSize.width,
        height: originalSize.height,
        style: {
          transform: "none",
          width: `${originalSize.width}px`,
          height: `${originalSize.height}px`,
        },
      })
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.download = `${title || "template"}.svg`;
          link.href = dataUrl;
          link.click();

          // 다시 숨기기
          downloadElement.style.position = "absolute";
          downloadElement.style.top = "-9999px";
          downloadElement.style.left = "-9999px";
          downloadElement.style.zIndex = "-1";
        })
        .catch((err) => {
          console.log("데스크탑 미리보기 SVG 생성 오류:", err);

          // 에러 시에도 다시 숨기기
          downloadElement.style.position = "absolute";
          downloadElement.style.top = "-9999px";
          downloadElement.style.left = "-9999px";
          downloadElement.style.zIndex = "-1";
        });
    }, 100);
  }, [originalSize, title]);

  useEffect(() => {
    window.scrollTo(0, 0);

    // 전체화면 진입 시 body 스크롤 비활성화
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    console.log("🖥️ 데스크탑 미리보기: 전체화면 모드 진입");
    const enterFullscreen = async () => {
      try {
        if (document.documentElement.requestFullscreen) {
          await document.documentElement.requestFullscreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          await document.documentElement.webkitRequestFullscreen();
        } else if (document.documentElement.msRequestFullscreen) {
          await document.documentElement.msRequestFullscreen();
        }
      } catch (error) {
        console.log("데스크탑 미리보기: 전체화면 모드 진입 실패:", error);
      }
    };

    enterFullscreen();

    // 컴포넌트 언마운트 시 스크롤 복원
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      onClose();
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    const handleFullscreenChange = () => {
      // 전체화면이 해제되면 미리보기도 종료
      if (!document.fullscreenElement) {
        onClose();
      }
    };

    window.addEventListener("popstate", handlePopState);
    window.addEventListener("keydown", handleKeyDown);
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, [onClose]);

  const handleGoBack = () => {
    // 전체화면 모드 해제
    const exitFullscreen = async () => {
      try {
        if (document.fullscreenElement) {
          if (document.exitFullscreen) {
            await document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            await document.webkitExitFullscreen();
          } else if (document.msExitFullscreen) {
            await document.msExitFullscreen();
          }
        }
      } catch (error) {
        console.log("데스크탑 미리보기: 전체화면 모드 해제 실패:", error);
      }
    };

    exitFullscreen().then(() => {
      onClose();
    });
  };

    const handleGoVertical = () => {
    setOrientation((prevOrientation) => {
      if (prevOrientation === "landscape") {
        setShowHeader(true);
        return "portrait";
      } else {
        setShowHeader(false);
        return "landscape";
      }
    });
  };


  // 미리보기용 컨텐츠 (화면을 완전히 채우도록)
  // const renderPreviewContent = () => {
  //   const finalTitleData = titleData || [];
  //   const finalMarkdownData = markdownData || [];


  //   return (
  //     <div
  //       ref={previewRef}
  //       style={{
  //         width: previewSize.width,
  //         height: previewSize.height,
  //         // transformOrigin: "center center",
  //          transformOrigin: "top left",
  //         overflow: "hidden",
  //         // display: "flex",
  //         // justifyContent: "center",
  //         // alignItems: "center",
  //       }}
  //     >
  //       <div
  //         style={{
  //           width: originalSize.width,
  //           height: originalSize.height,
  //           transform: `scale(${Math.min(
  //             previewSize.width / originalSize.width,
  //             previewSize.height / originalSize.height
  //           )})`,
  //           // transformOrigin: "center center",
  //            transformOrigin: "top left",
            
  //         }}
  //       >
  //         {contentsType === "link" ? (
  //         <MoleculeBackgroundSimpleWideLink
  //           contentsDesignConcept={contentsDesignConcept}
  //           title={finalTitleData}
  //           content={finalMarkdownData}
  //           linkUrl={linkUrl}
  //           logo={logo}
  //         />
  //         ) : (
  //           <MoleculeBackgroundSimpleWide
  //             contentsDesignConcept={contentsDesignConcept}
  //             title={finalTitleData}
  //             content={finalMarkdownData}
  //             logo={logo}
  //           />
  //         )}
  //       </div>
  //     </div>
  //   );
  // };


  // 미리보기용 컨텐츠 (화면을 완전히 채우도록)
  const renderPreviewContent = () => {
    const finalTitleData = titleData || [];
    const finalMarkdownData = markdownData || [];
    return (

      <CenterPanel orientation={orientation} themeMode={themeMode}>
          <CenterPanelContentWrapper orientation={orientation}>
            {contentsType === "link" ? (
              <MoleculeLinkContentInfoBoard
                contentsDesignConcept={contentsDesignConcept}
                title={finalTitleData}
                content={finalMarkdownData}
                // weatherData={weatherData}
                linkUrl={linkUrl}
                logo={logo}
                orientation={orientation}
                // onTogglePlay={onTogglePlay}
              />
            ) : (
              <MoleculeGeneralContentInfoBoard
                contentsDesignConcept={contentsDesignConcept}
                title={finalTitleData}
                content={finalMarkdownData}
                // weatherData={weatherData}
                logo={logo}
                orientation={orientation}
              />
            )}
         
          </CenterPanelContentWrapper>
        </CenterPanel>

    );
  };

  return (
   <PreviewContainer orientation={orientation}>
         <Header orientation={orientation} showHeader={showHeader}>
           <TitleContainer orientation={orientation} showHeader={showHeader}>
             <TemplateCategory>
               <Body3 color="primary" style={{ fontSize: "12px" }}>
                 {template?.category || "급식 메뉴"} (데스크탑)
               </Body3>
             </TemplateCategory>
             <HeaderTitle>{title || "급식 미리보기"} - 데스크탑</HeaderTitle>
           </TitleContainer>
           <ButtonGroup>
             <Button Large onClick={handleDownloadPng}>
               PNG로 저장
             </Button>
             <Button Large onClick={handleDownloadSvg}>
               SVG로 저장
             </Button>
             <Button Primary Large Fill onClick={handleGoVertical}>
               {orientation === "landscape" ? "세로 디스플레이로 전환" : "가로 디스플레이로 전환"}
             </Button>
             <Button Primary Large Fill onClick={handleGoBack}>
               미리보기 종료하기
             </Button>
           </ButtonGroup>
         </Header>
         
   <PreviewWrapper orientation={orientation}>
      <StyledSizeAreaContainer>
        {/* <MoleculeSizeArea
          title="내 디스플레이 (데스크탑)"
          width={
            displayWidth
              ? displayWidth.toString()
              : originalSize.width.toString()
          }
          height={
            displayHeight
              ? displayHeight.toString()
              : originalSize.height.toString()
          }
        /> */}
      </StyledSizeAreaContainer>

      <PreviewContent 
        orientation={orientation}
        onContextMenu={(e) => {
          e.preventDefault();
          // 컨텍스트 메뉴 대신 간단한 알림이나 동작
          const action = window.confirm(
            "미리보기를 종료하시겠습니까?\n확인: 종료\n취소: PNG 저장"
          );
          if (action) {
            handleGoBack();
          } else {
            handleDownloadPng();
          }
        }}
      >
        {renderPreviewContent()}
      </PreviewContent>
      
      {/* PNG/SVG 생성용 숨겨진 원본 사이즈 요소 */}
      <div
        ref={downloadRef}
        style={{
          position: "absolute",
          top: "-9999px",
          left: "-9999px",
          width: originalSize.width,
          height: originalSize.height,
          backgroundImage: `url(${Info_Background})`,
          backgroundSize: "cover",
          zIndex: -1,
        }}
      >
        <MoleculeBackgroundSimpleWide
          contentsDesignConcept={contentsDesignConcept}
          title={titleData}
          content={markdownData}
          logo={logo}
        />
      </div>
      </PreviewWrapper>
    </PreviewContainer>
  );
};

export default OrganismDisplayViewInfoPreviewDesktop;

// 데스크탑 전용 스타일 컴포넌트들
const PreviewContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  // background: #ebebeb;
  background: ${({ orientation }) => orientation === 'portrait' ? '#ebebeb' : `url(${Info_Background})`};
  // background: url(${Info_Background});
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 3px solid #ffd700; /* 데스크탑 구분용 골드 테두리 */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const Header = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 7px 14px;
  background: linear-gradient(
    135deg,
    #ffffff,
    #f8f9fa
  ); /* 데스크탑 구분용 그라데이션 */
  border-bottom: 2px solid #ffd700; /* 데스크탑 구분용 골드 테두리 */
  flex-shrink: 0;
      ${({ orientation, showHeader }) =>
    orientation === "portrait" && !showHeader &&
    `
    flex-wrap: wrap;
    justify-content: space-between;
  `};
`;

const TitleContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 12px;
    ${({ orientation, showHeader }) =>
    orientation === "portrait" && !showHeader &&
    `
    position: relative;
    left: auto;
    transform: none;
  `}
`;

const HeaderTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${palette.gray800};
`;

const PreviewContent = styled.div`
  flex: 1;
  overflow: hidden;
  margin: 0;
  background: transparent;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  /* orientation prop에 따른 동적 스타일 */
  padding: ${({ orientation }) =>
    orientation === "portrait" ? "16px" : "48px"};
  align-items: stretch; /* 내부 콘텐츠가 세로 영역을 모두 차지하도록 변경 */

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const TemplateCategory = styled.div`
  color: ${palette.primary};
  font-weight: 500;
  background-color: ${palette.primaryLightest};
  padding: 3px 8px;
  border-radius: 2px;
  border: 1px solid #ffd700; /* 데스크탑 구분용 골드 테두리 */
`;

const StyledSizeAreaContainer = styled.div`
  top: 56px;
  left: 0;
  right: 0;
  z-index: 99;
  background: rgba(255, 215, 0, 0.1); /* 데스크탑 구분용 골드 배경 */
`;


const CenterPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  --font-scaler: 12.2px;
  background: linear-gradient(
    136deg,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient01", themeMode)}
      0%,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient02", themeMode)}
      50%,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient03", themeMode)}
      100%
  );
  border-radius: 20px;
  margin: 10px;
  outline: 3px
    ${({ themeMode }) => getThemeColor("WeatherPanelOutline", themeMode)} solid; // color name = WeatherPanelOutline
  outline-offset: -3px;
  backdrop-filter: blur(12px);
  /* 기본 패딩을 가로 모드 기준으로 줄임 (경량화) */
  padding: 24px; /* 줄어든 기본 패딩 */

  // min-height: 80%; /* 최소 높이 지정 */
  overflow: hidden;

  flex-shrink: 1; /* shrink 허용 */

  ${({ orientation }) =>
    orientation === "portrait" && 
    `
    border-radius: 20px;
    margin: 5px;
    padding: 15px;
  `}
`;

//새로운 날씨 컨텐츠 래퍼 - 가로/세로 모드에 따라 다른 배치
const CenterPanelContentWrapper = styled.div`
  display: flex;
  flex-direction: row; /* 기본: 가로 배치 */
  flex: 1;
  align-items: stretch;

  /* 가로 모드: 모든 요소를 균등 분배 */
  ${({ orientation }) =>
    orientation === "landscape"
      ? `
    gap: 0;
    justify-content: space-between;
  `
      : `
    /* 세로 모드: 중앙 배치 */
    gap: 30px;
    justify-content: center;
  `}

  align-items: center;
  width: 100%;
  min-height: 0;
  flex-shrink: 1;
`;

const PreviewWrapper = styled.div`
  position: relative; /* fixed에서 relative로 변경 */
  flex: 1; /* 남은 공간을 모두 차지하도록 설정 */
  width: ${({ orientation }) =>
    orientation === "landscape" ? "100%" : "56.25vh"}; /* 9:16 비율 */
  height: ${({ orientation }) =>
    orientation === "landscape" ? "100vh" : "100vh"};
  background: ${({ orientation }) =>
    orientation === "portrait" ? `url(${Info_Background})` : `transparent`};
  z-index: 1; /* 헤더보다 낮은 z-index 설정 */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  left: 50%;
  transform: translateX(-50%);
  transition: width 0.3s ease-in-out;
`;